import React, { useState, useEffect } from 'react';
import RestaurantMap from './ReataurantMap';
import locationsMetadata from './locationsData';
import {Link} from 'react-router-dom';
import locationsData from './locationsData';
import { add } from 'date-fns';

export default function LocationsView({shops}) {
    let combinedLocations = null;
    if (!shops) {
      combinedLocations = locationsMetadata;
    } else {
      combinedLocations = locationsMetadata.map((location) => {
        const matchingShop = shops.find(shop => shop.shopId === location.id);
        if (matchingShop) {
            const addressComps = matchingShop.deliveryAddress.split(',')

            return(
              Object.assign({}, location, {
                address: [addressComps[0], addressComps[1] + addressComps[2]],
                phone: matchingShop.restuarantPhone,
                phoneLink: "+1" + matchingShop.restuarantPhone.replace(/[^0-9]/g, ''),
              })
            )
        }
        return location;
    })
    }
    

    return(
      <div id="pick-locations" role="main" aria-labelledby="location-header">

       
      
    <RestaurantMap />
    <div className="location-list">{combinedLocations.map(({id, disabled, buttonLabel, openingDate, label, address, phone, hours, phoneLink, orderLink, className="", external, storefrontPhoto}) => (
      <div key={id} className={"grid-item location " + className}>
      <div className="location-content-wrapper">
      <div className="location-list-content">
        <h3 className="title">{label}</h3>


        


       
        
        {!disabled && <div className="loc-menu-link">
        <a href={orderLink} 
        aria-label={`Order Pickup or Delivery for ${label} location at ${address[0]}, ${address[1]}`}
        className="menu-location-link">
        <span className="menu-button">Order Pickup / Delivery</span></a>

        <span className="separator">
        ·
        </span>
        <a 
        aria-label={`Menu for ${label} location at ${address[0]}, ${address[1]}`}
        href={orderLink} className="menu-location-link"><span className="menu-button">{"Menu"}</span></a>
        </div>}

       
        <div className="address">
        {address[0]} <br/>
        {address[1]}
        </div>
        <div className="phone">
        <a
        className="phone-link"
        href={`tel:${phoneLink}`}>{phone}</a>
        </div>
        <ul className="hours-of-operation">
        {hours.map((hours) => {
        return (<li key={hours.day}>
        <span className="">{hours.day}: {hours.hours}</span>
        {/* <span className="hours">{hours.hours}</span> */}
        </li>)
        })}
        </ul>

       
      </div>
      {storefrontPhoto && (
            <img 
              src={storefrontPhoto} 
              alt={`${label} storefront`}
              className="location-photo"
            />
          )}
      </div>
      </div>
    ))}
    </div>
    

    </div>  

    )
}